import colors from "@assets/colors";
import TypographyStyle from "@assets/typography";
import { StyleSheet } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    v_drawer_container: {
      zIndex: 3,
      width: 400,
      height: "100%",
      minHeight: "100%",
      maxHeight: "100%",
    },
    linear_style: {  
      width: "100%",
      height: "100%",
      paddingHorizontal: 55,
      position: "absolute",
      borderTopRightRadius: 30,
      borderBottomRightRadius: 30,
    },
  
    // DRAWER HEADER
    drawer_user_frame_container: {
      flex: 1,
      marginTop: 60,
      height: 300,
    },
    drawer_unawa_logo: { height: 56, width: 270 },
    user_edit_profile_container: {
      marginTop: 130,
    },
    v_details: { left: 15, paddingTop: '10%', justifyContent: "center" },
    t_welcome: {
      color: colors.white,
      fontSize: 50,
      lineHeight: 60,
      fontFamily: "DMSans-Bold",
      textTransform: "capitalize"
    },
    t_welcome_description: {
      fontSize: 20,
      marginTop: 16,
      lineHeight: 24,
      color: colors.white,
      fontFamily: "DMSans",
    },
    divider: { height: 1, backgroundColor: colors.blue },

    // SIGNUPNOW
    signupnow_container: {
      marginTop: 18,
    },
    btn_signupnow: {
      marginTop: 30,
      height: 47,
      borderRadius: 8,
      backgroundColor: colors.blue,
    },
    label_signupnow: {
      fontFamily: "DMSans-Bold",
      fontSize: 14,
      lineHeight: 14,
      color: colors.white,
    },
    logo:{
      alignItems: "center"
    },
    LogOutButton: {
      flexDirection: "row"
    },
    alignmentLogout: {
      paddingTop: "50%"
    },
    logOut_Guest: {
      fontSize: 20,
      lineHeight: 20,
      marginLeft: 20,
      fontFamily: "DMSans",
      color: colors.white,
    },
    // COPYRIGHT
    drawer_content_footer: {
      bottom: 10,
      left: 0,
      right: 0,
      position: "absolute",
      alignItems: "flex-start",
      justifyContent:"flex-start",
    },
    copyRightStyle: StyleSheet.flatten([
          TypographyStyle.copyRightText,
          { marginBottom: 20, left: "13%", color: colors.white },
        ]),
    copyRightBtnStyle: StyleSheet.flatten([
      TypographyStyle.copyRightButton,
      { fontWeight: "400" },
    ]),
    
  },
  {
    [DEVICE_SIZES.LG]: {
      drawer_user_frame_container: {
        marginTop: 47
      },
      v_drawer_container: {
        width: 300,
        minHeight: "100%",
        maxHeight: "100%",
      },
      alignmentLogout: {
        paddingTop: "15%"
      },
      logOut_Guest: {
        fontSize: 18
      },
      user_edit_profile_container: {
        marginTop: 120,
      },

      drawer_unawa_logo: { height: 61.5, width: 185.25 },
      t_welcome: { fontSize: 35, lineHeight: 45 },
      t_welcome_description: { fontSize: 15, lineHeight: 25 },
      linear_style: { 
        paddingHorizontal: 42,
        borderTopRightRadius: 22.5,
        borderBottomRightRadius: 22.5
      },
      // SIGNUPNOW
      signupnow_container: {
        marginTop: 0,
      },
      btn_signupnow: {
        height: 35,
        borderRadius: 6,
      },
      label_signupnow: {
        fontSize: 10.5,
        lineHeight: 10.5,
      },
    
      copyRightStyle: { fontSize: 9, lineHeight: 13.5, marginBottom: 10 },
      copyRightBtnStyle: { fontSize: 9, lineHeight: 13.5 },
    },
    [DEVICE_SIZES.MD]: {
      t_welcome: { fontSize: 24, lineHeight: 30, textAlign: "right", },
      t_welcome_description: { fontSize: 16, lineHeight: 25, textAlign: "right", },
      v_drawer_container: {
        zIndex: 3,
        width: "100%",
        height: "100%",
      },
      linear_style: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      LogOutButton: {
        flexDirection: "row",
        justifyContent:"center",
        alignItems:"center"
      },
      alignmentLogout: {
        paddingTop: "5%"
      },
    },
    [maxSize(DEVICE_SIZES.SM)]: {
      linear_style: {  
        width: "100%",
        height: "100%",
        paddingHorizontal: 15,
        position: "absolute",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      v_drawer_container: {
        flex: 1,
        width: "100%",
        height: "100%",
      },
      LogOutButton: {
        flexDirection: "row",
        justifyContent:"center",
        alignItems:"center"
      },
      alignmentLogout: {
        paddingTop: "7%",
        right: "2%"
      },
      t_welcome: {
        fontSize: 23,
        lineHeight: 30,
        textAlign: "right",
      },
      t_welcome_description: {
        fontSize: 15,
        lineHeight: 24,
        textAlign: "right",
      },
      btn_signupnow: {
        marginTop: 30,
        height: 47,
        borderRadius: 8,
        width:"100%"
      },
      user_edit_profile_container: {
        marginTop: 39,
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
    },
  }
);

export default useStyles;
